import type {
  AverageScoreTeamMode,
  Rarity,
} from '@sorare/core/src/__generated__/globalTypes';
import { Drawer } from '@sorare/core/src/atoms/layout/Drawer';
import { useScreenSize } from '@sorare/core/src/hooks/device/useScreenSize';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';
import { css } from '@sorare/css';

import { PlayerDetails } from '#src/shared/player/PlayerDetails/index.tsx';

const drawer = css`
  width: 100%;
  backdrop-filter: blur(64px);
  background-color: var(--c-nl-500);
  @media ${tabletAndAbove} {
    width: 480px;
  }
`;

type CardOpened = {
  cardSlug?: string;
  playerSlug: string;
};

export type Props = {
  cardOpened: CardOpened | null;
  onClose: () => void;
  withBuyingOptions?: {
    rarity: Rarity;
    inSeason: boolean;
    onMarketClick: (playerSlug: string) => void;
  };
  watchlistId?: string;
  favoritesWatchlist?: boolean;
  onboarding?: boolean;
  teamMode?: AverageScoreTeamMode;
};

export const PlayerDrawer = ({
  cardOpened,
  onClose,
  withBuyingOptions,
  watchlistId,
  favoritesWatchlist,
  onboarding,
  teamMode,
}: Props) => {
  const { up: isTabletOrAbove } = useScreenSize('tablet');
  const { up: laptopOrAbove } = useScreenSize('laptop');

  return (
    <Drawer
      className={drawer}
      open={!!cardOpened}
      side={isTabletOrAbove ? 'right' : 'bottom'}
      onBackdropClick={onClose}
    >
      {!!cardOpened && (
        <PlayerDetails
          playerSlug={cardOpened.playerSlug}
          cardSlug={cardOpened.cardSlug}
          onClose={onClose}
          watchlistId={watchlistId}
          {...(!laptopOrAbove && { withBuyingOptions })}
          favoritesWatchlist={favoritesWatchlist}
          onboarding={onboarding}
          teamMode={teamMode}
        />
      )}
    </Drawer>
  );
};
